exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "    :host {\r\n    display: flex;\r\n    background-color: #c6c6c6;\r\n    height: 60px;\r\n    padding-left: 20px;\r\n    align-items: center;\r\n    flex: 0 0 auto;\r\n}\r\n\r\n.title {\r\n    font-size: 28px;\r\n    color: #fff;\r\n    font-weight: bold;\r\n}\r\n\r\n.panel-buttons {\r\n    margin-left: auto;\r\n    display: flex;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./Scripts/fw/pages/page-subheader-bar.component.css
// module id = 2154
// module chunks = 1